export const HeightLocationModule={
    "TOP": "Верх",
    "BOTTOM": "Низ",
}